import React from 'react';
import { useNotifications } from '../../context/NotificationContext';

const ICONS = {
  success: '✓',
  error:   '✕',
  info:    'ℹ',
  warning: '⚠'
};

const TITLES = {
  success: 'Success',
  error:   'Error',
  info:    'Info',
  warning: 'Warning'
};

export const NotificationStack = () => {
  const ctx = useNotifications();
  if (!ctx) return null;
  const { notifications, remove } = ctx;

  return (
    <div className="notify-stack">
      {notifications.map((n) => (
        <div key={n.id} className={`notify notify-${n.type}`}>
          <div className="notify-icon">{ICONS[n.type]}</div>
          <div className="notify-body">
            <div className="notify-title">{n.title || TITLES[n.type]}</div>
            <div className="notify-msg">{n.message}</div>
          </div>
          <button className="notify-close" onClick={() => remove(n.id)}>×</button>
        </div>
      ))}
    </div>
  );
};
